/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';


interface InterventionsModerationTabProps {
  userId: any;
  filteredItems: any;
  thCls: any;
  tdCls: any;
  editingId: any;
  editForm: any;
  setEditForm: any;
  startEdit: any;
  cancelEdit: any;
  handleSave: any;
  handleDelete: any;
  resetIntervention: any;
  cancelIntervention: any;
}

const InterventionsModerationTab: React.FC<InterventionsModerationTabProps> = ({
  userId,
  filteredItems,
  thCls,
  tdCls,
  editingId,
  editForm,
  setEditForm,
  startEdit,
  cancelEdit,
  handleSave,
  handleDelete,
  resetIntervention,
  cancelIntervention,
}) => (
        <div className="overflow-x-auto rounded border border-[#33456f]">
          <table className="w-full min-w-[640px] border-collapse text-left">
            <thead>
              <tr>
                <th className={thCls}>N° / ID</th>
                <th className={thCls}>Adresse</th>
                <th className={thCls}>Statut</th>
                <th className={`${thCls} w-[1%]`}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((i: any) => {
                const isEd = editingId === Number(i.id);
                return (
                  <tr key={i.id}>
                    <td className={tdCls}>
                      {!isEd ? (
                        <span>
                          {i.numero_intervention} <span className="text-slate-500">(#{i.id})</span>
                        </span>
                      ) : (
                        <input
                          value={editForm.numero_intervention || ''}
                          onChange={(e) => setEditForm((f: any) => ({ ...f, numero_intervention: e.target.value }))}
                          className="w-full max-w-[200px] rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[11px] text-slate-100"
                        />
                      )}
                    </td>
                    <td className={tdCls}>
                      {!isEd ? (
                        i.adresse || '—'
                      ) : (
                        <input
                          value={editForm.adresse || ''}
                          onChange={(e) => setEditForm((f: any) => ({ ...f, adresse: e.target.value }))}
                          className="w-full min-w-[240px] rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 text-[11px] text-slate-100"
                        />
                      )}
                    </td>
                    <td className={tdCls}>
                      {!isEd ? (
                        <span className="rounded bg-[#1a2545] px-1.5 py-0.5 font-mono text-[10px]">{i.statut || '—'}</span>
                      ) : (
                        <input
                          value={editForm.statut || ''}
                          onChange={(e) => setEditForm((f: any) => ({ ...f, statut: e.target.value.toUpperCase() }))}
                          className="w-32 rounded border border-[#33456f] bg-[#0a1329] px-1.5 py-0.5 font-mono text-[11px] text-slate-100"
                        />
                      )}
                    </td>
                    <td className={tdCls}>
                      <div className="flex flex-col gap-1">
                        {!isEd ? (
                          <button type="button" onClick={() => startEdit(i)} className="rounded bg-amber-600 px-2 py-0.5 text-[10px] text-white">
                            Modifier
                          </button>
                        ) : (
                          <div className="flex flex-wrap gap-1">
                            <button type="button" onClick={() => void handleSave(userId, i)} className="rounded bg-emerald-600 px-2 py-0.5 text-[10px] text-white">
                              Enregistrer
                            </button>
                            <button type="button" onClick={cancelEdit} className="rounded bg-slate-600 px-2 py-0.5 text-[10px] text-white">
                              Annuler
                            </button>
                          </div>
                        )}
                        <button type="button" onClick={() => void resetIntervention(Number(i.id))} className="rounded bg-sky-800 px-2 py-0.5 text-[10px] text-white">
                          Reset
                        </button>
                        <button type="button" onClick={() => void cancelIntervention(Number(i.id))} className="rounded bg-orange-800 px-2 py-0.5 text-[10px] text-white">
                          Annuler int.
                        </button>
                        <button type="button" onClick={() => void handleDelete('interventions', userId, Number(i.id))} className="rounded bg-red-800 px-2 py-0.5 text-[10px] text-white">
                          Supprimer
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filteredItems.length === 0 && <p className="p-3 text-xs text-slate-400">Aucune intervention trouvée.</p>}
        </div>
);

export default InterventionsModerationTab;
